import WORKOUT_EXERCISES_DOMAIN from './domain'
import WORKOUT_EXERCISES_KEY from './key'

const WORKOUT_EXERCISES_PATH = {
  ALL: `${WORKOUT_EXERCISES_DOMAIN}.${WORKOUT_EXERCISES_KEY.ALL}`,
  CURRENT: `${WORKOUT_EXERCISES_DOMAIN}.${WORKOUT_EXERCISES_KEY.CURRENT}`,
  CURRENT_SET_INDEX: `${WORKOUT_EXERCISES_DOMAIN}.${WORKOUT_EXERCISES_KEY.CURRENT_SET_INDEX}`,
  DATA: `${WORKOUT_EXERCISES_DOMAIN}.${WORKOUT_EXERCISES_KEY.DATA}`
}

export default WORKOUT_EXERCISES_PATH
